var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfessional(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "avatars-pro",
    viewBox: "0 0 64 64",
    width: "100%",
    height: "100%",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.877853 4.27051l19.62916 14.26142c3.504874 2.54644 4.971455 7.060113 3.632712 11.18034l-7.497672 23.07546c-1.338743 4.120227-5.178302 6.90983-9.510565 6.90983H19.868512c-4.332263 0-8.171822-2.789603-9.510565-6.90983L2.860275 29.71227c-1.338743-4.120227.127838-8.6339 3.632712-11.18034l19.62916-14.26142c3.504875-2.54644 8.250831-2.54644 11.755706 0z",
    stroke: "#FFF",
    strokeWidth: 2,
    fill: "#0AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.218118 42.75257l-7.602196 4.643393c-.70698.431821-1.630162.20876-2.061983-.49822-.206578-.338211-.270917-.74443-.178962-1.129922l2.06692-8.665006c.130512-.547134-.056046-1.1213-.483229-1.487227l-6.765337-5.795231c-.629155-.538939-.70229-1.485866-.163352-2.115022.257822-.30098.624276-.487697 1.019317-.519368l8.879624-.711875c.560685-.04495 1.0491-.399804 1.265111-.919157l3.420988-8.225042c.318142-.764904 1.196123-1.127076 1.961027-.808935.36592.152195.65674.443015.808934.808935l3.420989 8.225042c.216011.519353.704426.874207 1.26511.919157l8.879625.711875c.825777.066203 1.441535.789295 1.375333 1.615073-.03167.39504-.218389.761496-.519368 1.019317l-6.765337 5.795231c-.427183.365928-.61374.940093-.48323 1.487227l2.066922 8.665006c.192217.805818-.305206 1.614887-1.111024 1.807104-.385493.091954-.791712.027615-1.129922-.178962l-7.602196-4.643393c-.480025-.293197-1.083739-.293197-1.563763 0z",
    fill: "#FFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfessional);
export default __webpack_public_path__ + "static/media/professional.ef858eb6d5d4b3335fc7776295ac738a.svg";
export { ForwardRef as ReactComponent };